/**
 * created by lei lei on 2020/5/28
 * 活动动态，选题动态
 */
import React, { Component } from 'react';
import ActivityTrends from './ActivityTrends';
import { Empty, message, Tabs, Spin } from 'antd';
import { formateData, headers } from "../../../../actions";
import {permissionCheck, timeago, uuid} from "../../../../utils";
import { connect } from "react-redux";
import moreImg from "../commImg/diandiandian.png";
import Card from '../../../components/card/Card'
import {
    shrinNavigateStauts,
    updateNavigateLevel2Data
} from "../../../../actions";
import NewsActivityBaseInfo, {NewsActivityBaseInfoFooter} from "../../../../components/interview/NewsActivityBaseInfo";
import NewsActivityPublishPlatform from "../../../../components/interview/NewsActivityPublishPlatform";
import NewsActivityReporter from "../../../../components/interview/NewsActivityReporter";
import TabModal from "../../../../components/TabModal";
import {getNewsActivityById} from "../../../../actions/interview";
import NewsActivityWriteStory from "../../../../components/interview/NewsActivityWriteStory";
import NewsActivityPicture from "../../../../components/interview/NewsActivityPicture";
import NewsActivityVideo from "../../../../components/interview/NewsActivityVideo";
import NewsActivityArtFile from "../../../../components/interview/NewsActivityArtFile";
import {haveEditAuthRoleCode} from "../../../../containers/newsActivity/NewsActivityIndex";
import {getById} from "../../../../actions/newsActivityAction";
const { TabPane } = Tabs;
let newActivityBaseInfoKey = uuid();
let plansToplatformKey = uuid();
let newsActivitySelectReporterKey = uuid();
class ActivityTrendsComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    ckqburl = "/interviewTask/interviewTask/1";

    dataSource1 = [];
    dataSource2 = [];
    maxNum = 5;

    constructor(props) {
        super(props);
        this.state = {
            list: [],
            loading: true,
            stepVisible: false,
            newsActivityViewVisible: false,
            newsActivityViewActiveIndex: 0,
            newsActivityViewTabs: [],
            newsActivityViewTabPanels: [],
            newsActivity: {},
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    initData() {
        getMyRemindByType(1, (data) => {
            if (data && data.data) {
                let list = data.data;
                {
                    list.map((item, i) => {
                        if (i < this.maxNum) {
                            this.dataSource1.push(item);
                        }
                    })
                }
                this.setState({
                    list: this.dataSource1,
                    loading: false
                })
            }
        });

        /*getMyRemindByType(2, (data) => {
            if (data && data.data) {
                let list = data.data;
                {
                    list.map((item, i) => {
                        if (i < this.maxNum) {
                            this.dataSource2.push(item);
                        }
                    })
                }
            }
        });*/
    }

    callback(key) {
        this.setState({
            list: []
        })
        this.ckqburl = "/interviewTask/interviewTask/" + key;
        if (key === "2") {
            this.ckqburl = "/topicSelectManager/topicSelectManager";
        }
        if (key == 1) {
            this.setState({
                list: this.dataSource1
            })
        } else {
            this.setState({
                list: this.dataSource2
            })
        }
    }

    findUrlData = (url) => {
        let sons;
        let name;
        let stopFind = false;

        let find = (data, level, levelOneBrothers, levelOneName) => {
            if (stopFind)
                return;
            if ((!data.sons || data.sons.length === 0) && (!data.float_ || data.float_.length === 0)) {
                if (data.path === url) {
                    sons = levelOneBrothers;
                    name = levelOneName;
                    stopFind = true;
                }
                return;
            }
            let tempSons = data.float_;
            if (!tempSons || tempSons.length === 0) {
                tempSons = data.sons;
            }
            if (stopFind)
                return;
            tempSons && tempSons.map(item => {
                if (stopFind)
                    return;
                let tempItemSons = item.float_;
                if (!tempItemSons || tempItemSons.length === 0) {
                    tempItemSons = item.sons;
                }
                if (level == 0) {//取第一级的信息
                    find(item, level + 1, tempItemSons, item.name);
                } else {
                    find(item, level + 1, levelOneBrothers, levelOneName);
                }
            })
        };
        find({ sons: this.props.navigateData }, 0, null, null);
        return { stopFind, sons, name };
    }

    gotoPage = (url) => {
        let { stopFind, sons, name } = this.findUrlData(url);
        if (stopFind) {
            this.props.shrinNavigateStauts();
            this.props.updateNavigateLevel2Data(name, sons);
            window.location.hash = url;
            return;
        }
        message.error("跳转失败！");
    }

    render() {
        const { loading } = this.state;
        let isAuth = permissionCheck("pms:taskActive:viewAll");//是否展示任务动态
        if(!isAuth){
            return <div></div>
        }

        return (
            <Card title="任务动态" style={{ marginTop: 20 }}>
                {
                    loading ? <div style={{ height: 390,textAlign: 'center', display:'flex', justifyContent: 'center', alignItems: 'center' }}><Spin /></div> : (
                        <div className={'activityContent'} style={(() => {
                            return this.state.list.length === 0 ? { height: 390,textAlign: 'center', display:'flex', justifyContent: 'center', alignItems: 'center' } : { height: 390}
                        })()}>
                            {this.state.list.length === 0 ? <Empty /> : this.state.list.map((item, i) => {
                                return (
                                    <ActivityTrends key={i}
                                        currentUser={item.currentUser}
                                        dataSourrce={item.message}
                                        statusMark={item._status}
                                        timeMark={timeago(item.creatDate.time)}
                                        showStatus={true}
                                        onClickItem={(data) => {
                                            this.showClickDialog(item);
                                        }}
                                    />
                                )
                            })}
                        </div>

                    )
                }
                <TabModal visible={this.state.newsActivityViewVisible}
                          onCancel={() => {
                              this.setState({
                                  newsActivityViewVisible: false
                              })
                          }}
                          activeIndex={this.state.newsActivityViewActiveIndex}
                          width={1100}
                          tabs={[{
                              title: "基本信息",
                              footer: <div className={"ant-modal-footer"}>
                                  <NewsActivityBaseInfoFooter
                                      currentUser={this.props.currentUser}
                                      data={this.state.newsActivity}
                                      showEditBtn={false}
                                      takeTaskAfter={() => {
                                          let {newsActivityViewTabs, newsActivityViewTabPanels} = this.handleNewsActivityViewTabs(this.state.newsActivity);
                                          this.setState({newsActivityViewTabs, newsActivityViewTabPanels})
                                      }}
                                      update={(id) => this.updateDataById(id)}
                                      cencel={() => {
                                          this.setState({
                                              newsActivityViewVisible: false
                                          })
                                      }}
                                  />
                              </div>
                          }, {
                              title: "拟发平台",
                              footer: null
                          }, {
                              title: "分派记者",
                              footer: null
                          }, ...this.state.newsActivityViewTabs]}
                          tabPanels={[<NewsActivityBaseInfo data={this.state.newsActivity}/>,
                              <NewsActivityPublishPlatform data={this.state.newsActivity}/>,
                              <NewsActivityReporter data={this.state.newsActivity}/>,
                              ...this.state.newsActivityViewTabPanels]}/>
             
            </Card>
        )
    }

    showClickDialog(obj) {
        console.log(obj)
        this.viewNewActivityById(obj.interviewId);
       /* if (obj && obj.length >= 2) {
            if (obj[0] === "interview") {
                showInterview(obj[1], "");
            }
        }*/
    }

    viewNewActivityById = (id) => {
        window.loading.show();
        getNewsActivityById(id, (newsActivity) => {
            window.loading.hide();
            let {newsActivityViewTabs, newsActivityViewTabPanels} = this.handleNewsActivityViewTabs(newsActivity);
            newsActivity.interviewJointers&& newsActivity.interviewJointers.length>0&&newsActivity.interviewJointers.forEach(item=>{
                if(item.status===3){
                    item.status=2
                }
            });
            this.setState({
                stepVisible: false,
                newsActivityViewVisible: true,
                newsActivityViewActiveIndex: 0,
                newsActivityViewTabs, newsActivityViewTabPanels,
                newsActivity
            });
        });
    };

    handleNewsActivityViewTabs(newsActivity) {
        let newsActivityViewTabs = [];
        let newsActivityViewTabPanels = [];
        let roleComponentMap = {
            type_1: {
                tab: {title: "任务稿件", footer: null}, tabPanel: <NewsActivityWriteStory refreshParentMethod={() => {
                    newsActivity.status = 3;
                    this.setState({newsActivity, newsActivityViewActiveIndex: 3})
                }} currentUser={this.props.currentUser} data={newsActivity}/>, push: false
            },
            type_2: {
                tab: {title: "任务图片", footer: null},
                tabPanel: <NewsActivityPicture currentUser={this.props.currentUser} data={newsActivity}/>,
                push: false
            },
            type_3: {
                tab: {title: "任务视频", footer: null},
                tabPanel: <NewsActivityVideo currentUser={this.props.currentUser} data={newsActivity}/>,
                push: false
            },
            type_4: {
                tab: {title: "美工附件", footer: null},
                tabPanel: <NewsActivityArtFile currentUser={this.props.currentUser} data={newsActivity}/>,
                push: false
            },
        };

        //先看看当前角色是不是主任，如果是主任的话，那就直接判断有没有人领取
        let isEditAuth = false;
        if (this.props.currentUser && this.props.currentUser.roleCodes) {
            // isEditAuth = this.props.currentUser.roleCodes.indexOf(haveEditAuthRoleCode) !== -1;
            isEditAuth=permissionCheck("pms:topicSelect:chooseUsing")
        }
        if (newsActivity && this.props.currentUser) {
            //查看当前的记者有哪些角色
            if (newsActivity.interviewJointers) {
                newsActivity.interviewJointers.map(jointer => {
                    if (isEditAuth || (jointer.account === this.props.currentUser.account)) {
                        //判断是否已经领取了
                        if (jointer.status !== 1 && !roleComponentMap["type_" + jointer.interviewRole].push) {//已领取才显示
                            newsActivityViewTabs.push(roleComponentMap["type_" + jointer.interviewRole].tab);
                            newsActivityViewTabPanels.push(roleComponentMap["type_" + jointer.interviewRole].tabPanel);
                            roleComponentMap["type_" + jointer.interviewRole].push = true;
                        }
                    }
                });
            }
        }

        return {newsActivityViewTabs, newsActivityViewTabPanels};
    }

    updateDataById(id){
        window.loading.show();
        getById(id).then(newsActivity=>{
            if(newsActivity.interviewDate){
                newsActivity.interviewDate = new Date(newsActivity.interviewDate.time);
            }
            if(newsActivity.endDate){
                newsActivity.endDate = new Date(newsActivity.endDate.time);
            }
            this.setState({
                stepVisible:true,
                newsActivityViewVisible:false,
                newsActivity
            });
            window.loading.hide();
        });
        newActivityBaseInfoKey = uuid();
        plansToplatformKey = uuid();
        newsActivitySelectReporterKey = uuid();
        // message.info("修改数据"+JSON.stringify(data),1);
    }
}

function mapStateToProps(state) {
    return {
        navigateData: state.systemReducer.navigateData,
        navigateStatus: state.systemReducer.navigateStatus,
    }
}

function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(ActivityTrendsComponents);

export const getMyRemindByType = (type, callBack) => {
    let url = "/cm-sites-pms/remind/getMyRemindByType";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({ type })
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMyRemindByType", error);
        callBack("");
    })
}

function showInterview(interviewId, title) {
    window.layer.open({
        id: "",
        //btn: ['确定', '关闭'],
        btn: null,
        type: 2,//0（信息框，默认）1（页面层）2（iframe层）3（加载层）4（tips层）。
        content: "/cm-sites/pms/interviewTask/interviewTaskdetail.html?interviewId=" + interviewId,
        title: title,
        resize: true,
        shade: 0.001,	//遮罩
        //shade : 0,
        //shadeClose : true,	//点击遮罩是否关闭
        zIndex: 100,
        area: [parseInt(window.$(window).width() * 0.9) + 'px', parseInt(window.$(window).height() * 0.9) + 'px'],
        yes: function (index, layero) {

        },
        end: function () {
        }
    })
}